import { getZodiacByName, ZodiacDomain } from "./Zodiac";
import { CardDomain, getCardByName } from "@/Cards";
import { iso8601ToDate } from "@/utils/iso8601ToDate";
import {
  CardOfTheDayDomain,
  CardOfTheDayDto,
  mapCardOfTheDayDtoToDomain,
} from "./Card";

export interface HomeInfoDto {
  activeSubscription: boolean;
  astrologicalSign: {
    id: number;
    name: string;
  };
  selectedLuckyCard: {
    id: number;
    name: string;
  };
  cardOfTheDay: CardOfTheDayDto | null;
  cardOfTheDayResetDate: string|null;
  generalForecastResetDate: string|null;
  personalForecastResetDate: string|null;
  luckyCardResetDate: string|null;

  isLuckyCardSelectionDateExpired: boolean;
  luckyCard: {
    id: number;
    name: string;
  };

}

export interface HomeInfoDomain {
  activeSubscription: boolean;
  astrologicalSign: ZodiacDomain | null;
  cardOfTheDay: CardOfTheDayDomain | null;
  selectedLuckyCard: CardDomain | null;
  isLuckyCardSelectionDateExpired: boolean;
  luckyCard: CardDomain | null;
  luckyCardResetDate: Date | null;
  generalForecastResetDate: Date | null;
  personalForecastResetDate: Date | null;
  cardOfTheDayResetDate: Date | null;
}

export const mapHomeInfoDtoToDomain = (dto: HomeInfoDto): HomeInfoDomain => {
  return {
    activeSubscription: dto.activeSubscription,
    astrologicalSign: getZodiacByName(dto.astrologicalSign.name),
    selectedLuckyCard: dto.selectedLuckyCard ? getCardByName(dto.selectedLuckyCard.name) : null,
    cardOfTheDay: dto.cardOfTheDay ? mapCardOfTheDayDtoToDomain(dto.cardOfTheDay,dto.cardOfTheDayResetDate) : null,
    isLuckyCardSelectionDateExpired: dto.isLuckyCardSelectionDateExpired,
    luckyCard: getCardByName(dto.luckyCard.name),
    luckyCardResetDate: dto.luckyCardResetDate ? iso8601ToDate(dto.luckyCardResetDate) : null,
    generalForecastResetDate: dto.generalForecastResetDate ? iso8601ToDate(dto.generalForecastResetDate) : null,
    personalForecastResetDate: dto.personalForecastResetDate ? iso8601ToDate(dto.personalForecastResetDate) : null,
    cardOfTheDayResetDate: dto.cardOfTheDayResetDate ? iso8601ToDate(dto.cardOfTheDayResetDate) : null,
  };
};
